import { arrayOf, bool, func, shape, string } from 'prop-types'
import React from 'react'

const Button = (props) => (
  <button
    className={props.isOpen ? 'button is-open' : 'button'}
    onClick={props.handleControlClick}
  >
    <i />
    <div>
      {props.options
        .filter(option => option.isChecked)
        .map(option => option.name)
        .join(', ') || 'All'}
    </div>
  </button>
)
Button.propTypes = {
  handleControlClick: func.isRequired,
  isOpen: bool.isRequired,
  options: arrayOf(shape({
    href: string.isRequired,
    isChecked: bool.isRequired,
    name: string.isRequired,
    value: string.isRequired,
  })).isRequired,
}

export default Button
